/**
 * @generated SignedSource<<51018c0e798f5d7503cf1615acd14705>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProUpgradeCard_billingAddress$data = {
  readonly city: string;
  readonly country: string;
  readonly postalCode: string;
  readonly street: string;
  readonly " $fragmentType": "ProUpgradeCard_billingAddress";
};
export type ProUpgradeCard_billingAddress$key = {
  readonly " $data"?: ProUpgradeCard_billingAddress$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProUpgradeCard_billingAddress">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProUpgradeCard_billingAddress",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "street",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postalCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    }
  ],
  "type": "BillingAddress",
  "abstractKey": null
};

(node as any).hash = "f37369dd17b3f14c8c0cd0a4967492e5";

export default node;
